import React, { memo } from 'react';
import { Row, Col } from 'react-bootstrap';
import { formatInTimeZone } from 'date-fns-tz';
import officialscoresheetStyles from '../../officialscoresheet.module.css';
import { ApparatusScoreSheetTable } from '../shared/tables';
import { Clock } from '../shared/clock';

const {
  header,
  row,
  virtiusTitle,
  sessionInfo,
  sessionInfoLabel,
  sessionInfoValue,
  body,
  footer,
  subFooter,
  timestamp,
} = officialscoresheetStyles;

function ApparatusScoresheetHeader({
  apparatus,
  abbvToApparatusName,
  sessionName,
  date,
  timezone,
  location,
  combineKey,
  combineKeys,
  combineSession,
  combinedSessions,
}) {
  return (
    <section className={header}>
      <h1>
        <span className={virtiusTitle}>
          <span>V</span>irtius&nbsp;
        </span>
        <span style={{ fontWeight: '700' }}>Score Sheet</span>
      </h1>
      <h2>
        {abbvToApparatusName[apparatus].toUpperCase()} RESULTS
        {combineKey || combineKeys.length > 0 ? ` (Combined Sessions)` : null}
      </h2>
      <section>
        <Row className={row}>
          <Col className={sessionInfo}>
            <div className={sessionInfoLabel}>
              Session{combineKey || combineKeys.length > 0 ? '(s)' : null}
              :&nbsp;
            </div>
            <div className={sessionInfoValue}>
              {sessionName}
              {combineKey ? ` + ${combineSession?.session?.name}` : null}
              {combineKeys.length > 0
                ? ` + ${combinedSessions
                    .filter((s) => s)
                    .map((s) => s.name)
                    .join(' + ')}`
                : null}
            </div>
          </Col>
        </Row>
        <Row className={row}>
          <Col className={sessionInfo}>
            <div className={sessionInfoLabel}>Date: </div>
            <div className={sessionInfoValue}>{`${formatInTimeZone(
              new Date(date),
              timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
              "M'/'dd'/'yyyy"
            )}`}</div>
          </Col>
        </Row>
        <Row className={row}>
          <Col className={sessionInfo}>
            <div className={sessionInfoLabel}>Location: </div>
            <div className={sessionInfoValue}>{location}</div>
          </Col>
        </Row>
      </section>
    </section>
  );
}

function ApparatusScoresheetBody({
  individuals,
  apparatus,
  apparatusArray,
  teamsByAthleteId,
}) {
  return (
    <main className={body}>
      <Row className={row}>
        <Col>
          <ApparatusScoreSheetTable
            individuals={individuals}
            apparatus={apparatusArray}
            teamsByAthleteId={teamsByAthleteId}
          />
        </Col>
      </Row>
    </main>
  );
}

function BasicScoresheetFooter({
  page,
  timezone,
  singleSheetOnly,
  sheetOptionsLength,
}) {
  const copyrightTimePageFooter = (page) => {
    return (
      <section className={subFooter}>
        <Row>
          <Col className={timestamp}>
            <span>
              © {new Date().getFullYear()} Virtius&nbsp;&nbsp;»&nbsp;&nbsp;
            </span>
            <Clock timezone={timezone} />
            <span>
              &nbsp;&nbsp;»&nbsp;&nbsp;Page {singleSheetOnly ? 1 : page} of{' '}
              {singleSheetOnly ? 1 : sheetOptionsLength}
            </span>
          </Col>
        </Row>
      </section>
    );
  };

  return <section className={footer}>{copyrightTimePageFooter(page)}</section>;
}

export const ApparatusScoreSheet = memo(_ApparatusScoreSheet);

function _ApparatusScoreSheet({
  page,
  apparatus,
  abbvToApparatusName,
  sessionName,
  date,
  timezone,
  location,
  combineKey,
  combineKeys,
  combineSession,
  combinedSessions,
  individuals,
  apparatusArray,
  teamsByAthleteId,
  singleSheetOnly,
  sheetOptionsLength,
}) {
  return (
    <>
      <ApparatusScoresheetHeader
        apparatus={apparatus}
        abbvToApparatusName={abbvToApparatusName}
        sessionName={sessionName}
        date={date}
        timezone={timezone}
        location={location}
        combineKey={combineKey}
        combineKeys={combineKeys}
        combineSession={combineSession}
        combinedSessions={combinedSessions}
      />
      <ApparatusScoresheetBody
        individuals={individuals}
        apparatus={apparatus}
        apparatusArray={apparatusArray}
        teamsByAthleteId={teamsByAthleteId}
      />
      <BasicScoresheetFooter
        page={page}
        timezone={timezone}
        singleSheetOnly={singleSheetOnly}
        sheetOptionsLength={sheetOptionsLength}
      />
    </>
  );
}
